import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navy text-ink" data-id="element-66" data-mp="3gezdb400vr15">
      <div className="h-1 w-full bg-electric" aria-hidden="true" data-id="element-67" data-mp="3gg1025qei1yp" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-68" data-mp="32oe281gt8ldt">
        <p className="text-xs" data-id="element-69" data-mp="32m1bayt2r0om">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}